export default __webpack_public_path__ + "static/media/betpannel_1.13414e7d.png";